import styled from 'styled-components';

export const Background = styled.div<{ heroBackgroundImage?: string }>`
  background-color: var(--color-hero-background-100);
  background-image: url(${props => props.heroBackgroundImage});

  &.ghost {
    background-image: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0.6) 0%,
        rgba(255, 255, 255, 0.6) 100%
      ),
      url(${props => props.heroBackgroundImage});
  }

  background-position: center;
  background-size: cover;
  height: 400px;

  &.top-background-position {
    background-position-y: top;
  }
  &.background-position-right {
    background-position-x: right;
  }
  &.background-no-repeat {
    background-repeat: no-repeat;
  }
  &.background-contain {
    background-size: contain;
  }

  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.maxWidth.S}) {
    height: 320px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 460px;
  margin: 0 40px;

  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.maxWidth.M}) {
    max-width: 100%;
    width: 100%;
    margin-top: 30px;
  }

  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.maxWidth.S}) {
    margin: 0 20px;
  }
`;

export const Hero = styled.div`
  color: ${({ theme }) => theme.colors.bigTitle()};
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 960px;
  padding: 40px 0;
  width: 100%;

  svg {
    stroke: ${({ theme }) => theme.colors.bigTitle()};
  }

  &.ghost {
    color: ${({ theme }) => theme.colors.textQuote()};

    svg {
      stroke: ${({ theme }) => theme.colors.textQuote()};
    }
  }

  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.maxWidth.XS}) {
    padding: 20px 10px;
  }
`;
